import { GTMMenuType } from '~/lib/models/gtm'

export const profileMenuSection = () => {
  const { t } = useNuxtApp().$i18nGlobal
  const countryCode = useCountry()

  const profile: {
    key: string
    title: string
    icon: string
    url: string
  }[] = [
    {
      key: GTMMenuType.PROFILE,
      title: t('profile.sections.personalData'),
      icon: '/images/icons/profileSections/profile.svg',
      url: `/${t('routes.profile')}/${t('routes.personalData')}`,
    },
  ]

  // Section hidden in CO (by the moment)
  if (countryCode !== 'CO') {
    profile.push({
      key: GTMMenuType.SAVED_ADDRESSES,
      title: t('profile.sections.addressSaved'),
      icon: '/images/icons/profileSections/location.svg',
      url: `/${t('routes.profile')}/${t('routes.mySavedAddresses')}`,
    })
  }

  profile.push(
    {
      key: GTMMenuType.MY_ORDERS,
      title: t('profile.sections.historyOrders'),
      icon: '/images/icons/profileSections/listView.svg',
      url: `/${t('routes.profile')}/${t('routes.orders')}`,
    },
    {
      key: GTMMenuType.SECURITY_AND_LOGIN,
      title: t('profile.sections.signInSecurity'),
      icon: '/images/icons/profileSections/privacy.svg',
      url: `/${t('routes.profile')}/${t('routes.signInSecurity')}`,
    }
  )

  return profile
}

export const getAsideTitle = (path: string) => {
  const currentSection = profileMenuSection().find(section => section.url === path)
  const sectionTitle = currentSection?.title || ''
  return sectionTitle
}
